import React, { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import { ShadowApp } from "../anonymous/components/App.js";
import { initializeSentry } from "@common/utils/sentry.js";

const HOST_ID = "xchat-embed-host";
const LEGACY_WIDGET_ID = "xchat-embed";

function getEmbedScriptEl(): HTMLScriptElement | null {
    const current = document.currentScript as HTMLScriptElement | null;
    if (current) {
        return current;
    }

    const marked = document.querySelector("script[data-xchat-embed]");
    if (marked) {
        return marked as HTMLScriptElement;
    }

    try {
        const fileName = new URL(import.meta.url).pathname.split("/").pop() || "embed.js";
        const scripts = document.querySelectorAll("script[type=module][src]");
        for (let i = scripts.length - 1; i >= 0; i--) {
            const el = scripts[i] as HTMLScriptElement;
            const resolved = new URL(el.src, document.baseURI);
            if (resolved.pathname.endsWith(fileName)) {
                return el;
            }
        }
    } catch {
        /* ignore */
    }

    return null;
}

function initEmbed() {
    document.getElementById(LEGACY_WIDGET_ID)?.remove();
    if (document.getElementById(HOST_ID)) {
        return;
    }

    const script = getEmbedScriptEl();
    const apiKey = script?.getAttribute("data-api-key")?.trim() ?? "";
    const systemInformations = script?.getAttribute("data-system-informations")?.trim() ?? null;

    const host = document.createElement("div");
    host.id = HOST_ID;
    host.setAttribute("title", "XChat");
    Object.assign(host.style, {
        position: "fixed",
        bottom: "20px",
        right: "20px",
        width: "440px",
        height: "auto",
        maxHeight: "calc(100vh - 40px)",
        maxWidth: "calc(100vw - 40px)",
        border: "none",
        background: "transparent",
        zIndex: "2147483646",
    } as CSSStyleDeclaration);

    document.body.appendChild(host);

    initializeSentry();
    const root = ReactDOM.createRoot(host);
    root.render(
        <StrictMode>
            <ShadowApp embedAccessApiKey={apiKey || null} embedSystemInformations={systemInformations} />
        </StrictMode>,
    );
}

initEmbed();
